

export function OrSeparator() {
    return (
        <p className="m-0 flex w-full flex-row items-center">
            <span className="h-px grow bg-chip"></span>
            <span className="block px-4 font-bold text-subtle">
                Or
            </span>
            <span className="h-px grow bg-chip"></span>
        </p>
    );
}
